import { Delete } from "@mui/icons-material";

import CoAppDataGridDateTimeCell from "../../../../global/components/datagrid/CoAppDataGridDateTimeCell";
import CoAppDataGridNameCell from "../../../../global/components/datagrid/CoAppDataGridNameCell";
import CoAppDataGridSkeletonCell from "../../../../global/components/datagrid/CoAppDataGridSkeletonCell";
import { CoAppDataGridActionsContainer } from "../../../../global/styled/global.styled";

export const groupIdpGroupColumns = ["actions", "name", "createdAt"];

export const getGroupSSOColumns = (
	loading,
	identityProviderName,
	removeIdPGroupFromGroup
) => [
	{
		field: "name",
		headerName: identityProviderName ? `${identityProviderName} Group` : "Group",
		disableExport: true,
		editable: true,
		sortable: true,
		flex: 1,
		renderCell: (params) => (
			<CoAppDataGridSkeletonCell
				cellToRender={<CoAppDataGridNameCell item={params.row} />}
				isLoading={loading}
			/>
		),
	},
	{
		field: "createdAt",
		headerName: "Date Mapped",
		disableExport: true,
		editable: true,
		sortable: true,
		flex: 1,
		valueGetter: (params) => !params ? null : new Date(params),
		renderCell: (params) => (
			<CoAppDataGridSkeletonCell
				cellToRender={<CoAppDataGridDateTimeCell value={params.value} />}
				isLoading={loading}
			/>
		),
	},
	{
		field: "actions",
		disableExport: true,
		type: "actions",
		flex: .1,
		sortable: false,
		renderCell: (params) => (
			<CoAppDataGridSkeletonCell
				cellToRender={
					<CoAppDataGridActionsContainer>
						<Delete
							onClick={() => {
								removeIdPGroupFromGroup(params.row.id);
							}}
						/>
					</CoAppDataGridActionsContainer>
				}
				isLoading={loading}
			/>
		),
	},
];